// ShowcaseDispaly.js
class ShowcaseDisplay {
    constructor() {
        this.showcaseCards = document.querySelectorAll('.showcase-card');
        this.display = document.getElementById('showcase-card-display');
        this.lastValidContent = null;  // Store the last valid display content
        this.events();
        this.initialDisplay();  // 페이지 로드 시 첫 번째 카드의 내용을 자동으로 표시
    }

    events() {
        this.showcaseCards.forEach(card => {
            card.addEventListener('click', (e) => {
                const postId = card.getAttribute('data-post-id');
                const designName = card.getAttribute('data-design-name');
                const postTitle = card.getAttribute('data-post-title');
                const imageOrVideosJson = JSON.parse(card.getAttribute('data-image-or-videos-json'));

                this.updateDisplay(postId, designName, postTitle, imageOrVideosJson);
            });
        });
    }

    initialDisplay() {
        if (this.showcaseCards.length > 0) {
            const firstCard = this.showcaseCards[0];
            const postId = firstCard.getAttribute('data-post-id');
            const designName = firstCard.getAttribute('data-design-name');
            const postTitle = firstCard.getAttribute('data-post-title');
            const imageOrVideosJson = JSON.parse(firstCard.getAttribute('data-image-or-videos-json'));

            this.updateDisplay(postId, designName, postTitle, imageOrVideosJson);
        }
    }

    updateDisplay(postId, designName, postTitle, imageOrVideosJson) {
        fetch('/wp-admin/admin-ajax.php?action=fetch_post_media&post_id=' + postId)
        .then(response => response.json())
        .then(data => {
            if (!data.error) {
                this.display.innerHTML = data.html;
                var titleElement = document.createElement('h2');
                titleElement.textContent = designName;
                this.display.prepend(titleElement);
    
                const designerInfoDiv = document.createElement('div');
                designerInfoDiv.className = 'accordion';
                const projectDescriptionHeader = document.createElement('h3');
                projectDescriptionHeader.textContent = "Project Description";
    
                // Add Font Awesome icon next to the header
                const iconElement = document.createElement('i');
                iconElement.className = "fas fa-chevron-up accordion-icon";
                projectDescriptionHeader.appendChild(iconElement);
    
                designerInfoDiv.appendChild(projectDescriptionHeader);
                designerInfoDiv.innerHTML += data.additional_info;
                this.display.appendChild(designerInfoDiv);
    
                // 아코디온 기능 추가
                this.addAccordionFunctionality();
    
                const swiperContainer = this.display.querySelector('.swiper-container');
                if (swiperContainer) {
                    const paginationElement = document.createElement('div');
                    paginationElement.className = 'swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-vertical';
                    swiperContainer.appendChild(paginationElement);
                }
    
                const images = this.display.querySelectorAll('img');
                let loadedCount = 0;
    
                const checkAllImagesLoaded = () => {
                    if (loadedCount === images.length) {
                        this.initializeSwiper(); // 모든 이미지가 로드된 후 Swiper 초기화
                    }
                };
    
                if (images.length === 0) {
                    this.initializeSwiper(); // 이미지가 없는 경우 바로 Swiper 초기화
                } else {
                    images.forEach(img => {
                        if (img.complete) {
                            loadedCount++;
                            checkAllImagesLoaded();
                        } else {
                            img.onload = () => {
                                loadedCount++;
                                checkAllImagesLoaded();
                            };
                        }
                    });
                }
                
                this.lastValidContent = this.display.innerHTML;  // Update the last valid content
                // Highlight the active card
                this.highlightActiveCard(postId);
            } else {
                // this.display.innerHTML = '<p>' + data.error + '</p>';
                    // Handle fetch error
                    this.highlightActiveCard(postId);
                    console.error(data.error);
                    this.showNoMediaAlert();
            }
        });
    }
    
    showNoMediaAlert() {
        // Remove existing overlay if it exists
        const existingOverlay = this.display.querySelector('.overlay');
        if (existingOverlay) {
            this.display.removeChild(existingOverlay);
        }
    
        this.display.classList.add('display-relative'); // Ensure the display container is positioned relatively
    
        const alertBox = document.createElement('div');
        alertBox.className = 'alert-box'; // Assign class for styling via SCSS
        alertBox.textContent = "Sorry, there is no media available for this post.";
    
        const overlay = document.createElement('div');
        overlay.className = 'alert-overlay'; // Assign class for overlay styling
        overlay.appendChild(alertBox);
        /*
        overlay.addEventListener('click', () => {
            this.display.removeChild(overlay);
        });
         */
        this.display.appendChild(overlay);
    }
    
    
    
    highlightActiveCard(activePostId) {
        const styleSheet = document.getElementById('active-card-style') || document.createElement('style');
        if (!document.getElementById('active-card-style')) {
            styleSheet.id = 'active-card-style';
            document.head.appendChild(styleSheet);
        }
    
        this.showcaseCards.forEach(card => {
            if (card.getAttribute('data-post-id') === activePostId) {
                // Set unique ID to each card for specific targeting
                card.id = `showcase-card-${activePostId}`;
                styleSheet.textContent = `
                    #showcase-card-${activePostId}::after {
                        background-color: white !important;
                        opacity: 0.7 !important;
                    }
                    #showcase-card-${activePostId} h2 {
                        color: black !important;
                        font-weight: 500;
                    }
                `;
            } else {
                card.id = ''; // Remove ID if not active
            }
        });
    }
    
    
    initializeSwiper() {
        if (window.mySwiper) {
            window.mySwiper.destroy(true, true);
        }
        window.mySwiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            loop: true,
            autoHeight: true,
            slidesPerView: 1,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
    

    addAccordionFunctionality() {
        const accordions = this.display.querySelectorAll('.accordion');
        accordions.forEach(accordion => {
            accordion.addEventListener('click', function() {
                this.classList.toggle('active');
                const blockColumn = this.querySelector('.wp-block-column');
                const icon = this.querySelector('.accordion-icon');
                if (blockColumn.style.maxHeight) {
                    blockColumn.style.maxHeight = null;
                    icon.style.transform = 'rotate(0deg)'; // Reset the rotation
                } else {
                    blockColumn.style.maxHeight = blockColumn.scrollHeight + 'px';
                    icon.style.transform = 'rotate(180deg)'; // Rotate the icon 180 degrees
                }
            });
        });
    }
}
document.addEventListener('DOMContentLoaded', function () {
    // Ensure Swiper is loaded
    if (typeof Swiper === "undefined") {
        console.error("Swiper not loaded");
    } else {
        // const showcaseDisplay = new ShowcaseDisplay();
        new ShowcaseDisplay();
    }
});

export default ShowcaseDisplay;
